export enum CardTypes {
    DEFAULT = 'default',
    TRASH = 'trash',
    FAVORITE = 'favorite',
}